import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoutingServersComponent } from './routing-servers.component';
import {ArmSideNavModule} from '../../components/arm-side-nav/arm-side-nav.module';
import { RoutingServersSettingsComponent } from './routing-servers-settings/routing-servers-settings.component';
import { RoutingServersGroupsSettingsComponent } from './routing-servers-groups-settings/routing-servers-groups-settings.component';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import { ServerDialogComponent } from './routing-servers-settings/server-dialog/server-dialog.component';
import {FormsModule} from '@angular/forms';
import {MaterialModule} from '../../material.module';
import {DividerModule} from '../../components/separator/divider.module';
import {ClientFilterModule} from '../../components/client-filter/client-filter.module';
import { ServerCertificateDialogComponent } from './routing-servers-settings/server-certificate-dialog/server-certificate-dialog.component';
import {CertificatesModule} from '../../components/certificates/certificates.module';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {ArmFormModule} from '../../components/arm-form/arm-form.module';
import {InfraModule} from 'ac-infra';
import { RoutingServerGroupDialogComponent } from './routing-servers-groups-settings/routing-server-group-dialog/routing-server-group-dialog.component';
import { RoutingServerSettingsSearchComponent } from './routing-servers-settings/routing-server-settings-search/routing-server-settings-search.component';
import { RoutingServersGroupsSettingsSearchComponent } from './routing-servers-groups-settings/routing-servers-groups-settings-search/routing-servers-groups-settings-search.component';
import {SearchModule} from '../../components/search/search.module';
import {DialogModule} from '../../components/dialog/dialog.module';
import { RoutingServerGroupMainDialogComponent } from './routing-servers-groups-settings/routing-server-group-main-dialog/routing-server-group-main-dialog.component';
import { RoutingPolicyPipe } from './routing-servers-groups-settings/policy-between-groups.pipe';
import {PipsModule} from '../../pipes/pips.module';




@NgModule({
  declarations: [RoutingServersComponent, RoutingServersSettingsComponent, RoutingServersGroupsSettingsComponent,
    ServerDialogComponent, ServerCertificateDialogComponent, RoutingServerGroupDialogComponent,
    RoutingServerSettingsSearchComponent, RoutingServersGroupsSettingsSearchComponent, RoutingServerGroupMainDialogComponent,
    RoutingPolicyPipe],
  imports: [
    CommonModule,
    ArmSideNavModule,
    ActionBarModule,
    ArmTableModule,
    FormsModule,
    MaterialModule,
    DividerModule,
    ClientFilterModule,
    CertificatesModule,
    VirtualScrollerModule,
    ArmFormModule,
    InfraModule,
    SearchModule,
    DialogModule,
    PipsModule
  ]
})
export class RoutingServersModule { }
